import React from "react";

const ContactPersonInfo = ({ photo, text, width }) => {
  return (
    <div className="contact_person_info_out_main">
      <img src={photo} alt="person" />
      <h2 style={{ width: width }}>{text}</h2>
    </div>
  );
};

export default ContactPersonInfo;
